import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>&iquest;Est&aacute;s perdido? esta p&aacute;gina no existe!</h3>
  </div>;



// WEBPACK FOOTER //
// ./src/containers/NotFound.js